<template>
  <div class="modal-backdrop">
    <div class="modal">
      <header class="modal-header" v-if="$slots.header">
        <slot name="header"> </slot>
        <button type="button" class="btn-close" @click="close">
          <b-icon icon="times" type="is-white"> </b-icon>
        </button>
      </header>

      <section class="modal-body">
        <slot name="body"></slot>
      </section>

      <footer class="modal-footer" v-if="$slots.footer">
        <slot name="footer"></slot>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: "Modal",
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.modal-backdrop > .modal {
  background: #484848;
  overflow-x: auto;
  display: flex !important;
  flex-direction: column;
  position: static;
  width: 380px;
  color: #fff;
  border-radius: 3px;
}

.modal-header,
.modal-body,
.modal-footer {
  width: 100%;
}

.modal-header,
.modal-footer {
  padding: 15px;
  display: flex;
}

.modal-header {
  position: relative;
  background: #333;
  justify-content: space-between;
  align-items: center;
  font-weight: 700;
  font-size: 16px;
}

.modal-footer {
  flex-direction: column;
  justify-content: flex-end;
}

.modal-body {
  position: relative;
  padding: 20px 10px;
}

.btn-close {
  border: none;
  font-size: 20px;
  padding: 10px;
  cursor: pointer;
  font-weight: bold;
  color: #4aae9b;
  background: transparent;
  padding: 0;
  margin-left: 10px;
}
</style>
